'use client'

import * as React from 'react'
import { tw } from 'utils/classnames'
import { XCloseIcon } from 'primitives/icons'
import { CalendarDaysFasIcon } from 'primitives/icons/time'
import { GearFasIcon } from 'primitives/icons/general'
import { PassportFasIcon } from 'primitives/icons/maps-and-travel'

import { useUserCapabilitiesQuery } from '@web/gen/user'

interface EditProductProps {
  productId: string
  publishedOn: string
}

export const EditProduct = ({ productId, publishedOn }: EditProductProps) => {
  const [isExpanded, setIsExpanded] = React.useState(false)
  const userCapabilitiesQuery = useUserCapabilitiesQuery()

  if (
    userCapabilitiesQuery.isPending ||
    (!userCapabilitiesQuery.data?.me?.user?.capabilities.includes('dashboard_general') &&
      !userCapabilitiesQuery.data?.me?.user?.capabilities.includes('dashboard_categories'))
  ) {
    return null
  }

  return (
    <div
      className={tw(
        isExpanded ? 'max-h-[750px] w-[300px]' : '',
        'bg-service-white fixed right-0 top-[130px] z-[9999] flex min-h-[33px] min-w-[46px] items-center justify-center rounded-l-[3px] py-[5px] shadow-xl transition-all duration-500 ease-in-out',
      )}
    >
      {isExpanded ? (
        <div className="flex w-full flex-col p-[10px]">
          <div className="flex w-full justify-between">
            <a
              target="_blank"
              href={`${process.env.NEXT_PUBLIC_CF_URL}/admin-dashboard/admin-manage/sp-delete-product/?productId=${productId}`}
              className="font-500 text-cf-white flex w-fit cursor-pointer items-center justify-center rounded bg-[#3ab561] p-[5px] text-xs hover:bg-[#248142]"
              rel="noreferrer"
            >
              Remove
            </a>
            <div
              className="flex h-[28px] w-[28px] cursor-pointer items-center justify-center rounded bg-[#f7f8fa]"
              onClick={() => setIsExpanded(false)}
            >
              <XCloseIcon className="h-[16px] w-[16px] text-[#74788d]" />
            </div>
          </div>
          <div className="mt-5 flex flex-col gap-2">
            <div className="flex">
              <PassportFasIcon className="h-[16px] w-[16px] text-[#1dc9b7]" />
              <div className="ml-3 text-xs font-bold text-[#595D71]">Product ID</div>
              <div className="ml-1 text-[11px] font-bold text-[#74788d]">{productId}</div>
            </div>
            <div className="flex">
              <CalendarDaysFasIcon className="h-[16px] w-[16px] text-[#5d78ff]" />
              <div className="ml-3 text-xs font-bold text-[#595D71]">Published on</div>
              <div className="ml-1 text-[11px] font-bold text-[#74788d]">
                {new Date(publishedOn).toLocaleDateString('en-us', {
                  month: 'long',
                  year: 'numeric',
                  day: 'numeric',
                })}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <GearFasIcon
          className="h-[16px] w-[16px] cursor-pointer text-[#3ab561] hover:text-[#248142]"
          onClick={() => setIsExpanded(true)}
        />
      )}
    </div>
  )
}
